import {EnrollPrivilegesItems} from './enroll-privileges-items';

export class EnrollPrivileges {
  privileges: EnrollPrivilegesItems[] = [];
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-privileges.ts